/** 這裡存放所有用到的LocalStorage KeyName, 以及其儲存的格式！ */
export enum LocalStorageKey {
    User = 'user',
    AccessToken = 'access_token',
    RefreshToken = 'refresh_token',
    VolunteerFirstRun = 'volunteer_firstrun',
    VolunteerToken = 'volunteer_token',
    Registration = 'registration'
}